import styled from 'styled-components';

import config from 'config';

import Card from 'components/common/Card';
import { dropIn } from 'components/Animations';

const BASENAME = config.site.baseName;

const PROPS_LOGO = {
  src: `${BASENAME ? '/' : ''}${BASENAME}/img/logo.png`
};

export const AppBarDisplay = styled(Card.Content)`
  width: 100vw;
  height: 88px;
  position: fixed;

  top: 0px;
  padding: 0px;
  display: flex;
  z-index: 9999999;
  border-radius: 0px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  box-shadow: rgba(0, 0, 0, 0.04) 3px 1px 3px 3px,
    rgba(0, 0, 0, 0.17) 3px -1px 1px 2px;

  padding: 0px !important;

  ${(props) => (props.intro ? dropIn('88px') : '')};
`;

export const AppBarInner = styled.div`
  flex: 1;
  display: flex;
  padding: 0px 24px;
  max-width: 1600px;
  align-items: center;

  ${(props) => props.theme.media.xl.max`
    max-width: 1366px;
  `}

  justify-content: flex-start;
`;

export const AppBarLogo = styled.img`
  max-height: 40px;
  margin-right: 16px;
`;

AppBarLogo.defaultProps = PROPS_LOGO;

export const AppBarFlex = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start; };
`;

export const AppBarBackButton = styled.div`
  top: 2px;
  width: 42px;
  cursor: pointer;
  user-select: none;
  margin-right: 8px;
  position: relative;
  display: inline-flex;
  z-index: 999999;
`;

export const Link = styled.button`
  border: none;
  display: flex;
  border-radius: 4px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  font-family: 'Roboto';
  background-color: unset;
  font-size: 0.875em;
  color: #495057;
  padding: 0px 1em;
  line-height: 2.8em;
  box-shadow: 0px 0px 0px 1px #c7d7e1;
  transition: all 0.15s ease-in-out;
  margin-left: 1em;

  &:hover {
    opacity: 0.8 !important;
  }

  &:active {
    opacity: 0.5 !important;
  }
`;
